module.exports = __webpack_public_path__ + "static/cf-bold-italic-ext-dafb6759217a33c3cbd27dcc55d2dbd9.ttf";